import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

// ── Queries ───────────────────────────────────────────────────────────────────

export function useAssociates(status) {
  const params = status ? `?status=${status}` : '';
  return useQuery({
    queryKey: ['associates', { status }],
    queryFn: () => api.get(`/associates${params}`),
    staleTime: 30_000,
  });
}

export function useAssociate(id) {
  return useQuery({
    queryKey: ['associates', id],
    queryFn: () => api.get(`/associates/${id}`),
    staleTime: 30_000,
    enabled: Boolean(id),
  });
}

// ── Mutations ─────────────────────────────────────────────────────────────────

function useAssociateMutation(mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['associates'] });
    },
  });
}

export function useCreateAssociate() {
  return useAssociateMutation((body) => api.post('/associates', body));
}

export function useUpdateAssociate() {
  return useAssociateMutation(({ id, ...body }) => api.patch(`/associates/${id}`, body));
}

export function useDeleteAssociate() {
  return useAssociateMutation((id) => api.delete(`/associates/${id}`));
}
